<template>
    <sidebar-menu :items="items" has-icon :force-expanded="forceExpanded" @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import { mapState } from 'vuex';
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';
import TermSchedule from '@/models/term-schedule/TermSchedule.js';

export default {
    name: 'GroupSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    data: () => ({
        hasTermSchedule: false,
    }),
    props: {
        forceExpanded: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        ...mapState('Auth', { user: state => state.user }),

        groupId() {
            return parseInt(this.$route.params.groupId, 10);
        },

        activePageFolder() {
            return this.$store.state.entities.dashboard.activePageFolder;
        },

        items() {
            const groupsMenuOptions = [
                {
                    type: 'item',
                    title: 'Members',
                    route: { name: 'group-view' },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'user',
                },
                {
                    type: 'item',
                    title: 'Courses',
                    route: { name: 'group-courses-view' },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'book',
                },
                {
                    type: 'item',
                    title: 'Evaluations',
                    route: {
                        name: 'group-evaluations-view',
                        params: { groupId: this.$route.params.groupId },
                    },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'clipboard',
                },
            ];

            const termsMenuOption = [
                {
                    type: 'folder',
                    title: 'Terms',
                    hasIcon: true,
                    icon: 'folder',
                    displayItemsAlways: true,
                    items: [
                        {
                            type: 'item',
                            title: 'Templates',
                            route: {
                                name: 'group-term-templates-index',
                                params: { groupId: this.$route.params.groupId },
                            },
                            canSee: this.$gate.allows('view', ['TermTemplate']),
                        },
                        {
                            type: 'item',
                            title: 'Schedules',
                            route: {
                                name: 'group-term-schedules-index',
                                params: { groupId: this.$route.params.groupId },
                            },
                            canSee: this.$gate.allows('view', ['TermSchedule']),
                        },
                        {
                            type: 'item',
                            title: 'Assigned Schedules',
                            route: {
                                name: 'assigned-group-term-schedule-index',
                                params: { groupId: this.groupId },
                            },
                            canSee: true,
                            icon: 'list-ul',
                        },
                    ],
                    canSee: this.$gate.allows('view', ['TermTemplate']),
                },
            ];

            // return Group.find(this.$route.params.groupId)?.has_terms
            //     ? [...groupsMenuOptions, ...termsMenuOption]
            //     : groupsMenuOptions;
            return [...groupsMenuOptions, ...termsMenuOption];
        },
    },

    async created() {
        await TermSchedule.fetchGroupTermSchedules(this.groupId);

        this.hasTermSchedule = !!TermSchedule.query().where('group_id', this.groupId).count();
    },
};
</script>
